import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-infos',
  templateUrl: './user-infos.component.html',
  styleUrls: ['./user-infos.component.scss']
})
export class UserInfosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
